import { render, staticRenderFns } from "./queueCard.vue?vue&type=template&id=3eaa53e3&"
import script from "./queueCard.vue?vue&type=script&lang=js&"
export * from "./queueCard.vue?vue&type=script&lang=js&"
import style0 from "./queueCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports